import { HappyToCareLine } from 'Components/lines/happy-to-care-line/HappyToCareLine';
export default HappyToCareLine;
